import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span
      className={cn('inline-flex items-center gap-2 text-xs text-muted-foreground', className)}
      role={label ? 'status' : undefined}
    >
      <Loader2 className="size-3.5 animate-spin" aria-hidden />
      {label && <span>{label}</span>}
    </span>
  );
}
